import script from "./resourcecenter.vue?vue&type=script&setup=true&lang=js"
export * from "./resourcecenter.vue?vue&type=script&setup=true&lang=js"

import "./resourcecenter.vue?vue&type=style&index=0&id=5b865187&lang=less"

const __exports__ = script;

export default __exports__